import Vue from 'vue'
import { instance, errorService } from '@/services/api'
import { rolePermissions, checkFields, costTypes } from '@/services/config'
import { masterAPIs } from '@/services/authConstantsV1'
import { Tooltip } from 'ant-design-vue'
import _ from 'lodash'

Vue.use(Tooltip)

export default Vue.extend({
  template: `
    <div>
      <span>
        <a-spin :spinning="loader">
          <a-icon slot="indicator" type="loading" spin />
          <a-tooltip placement="top" title="Unlink Asset" v-if="params.type === 'projectDetails' && params.data.linkedAssetId">
            <a @click='() => unLink()'>
              <i class='fa fa-chain-broken templateIcon mr-2' aria-hidden='true' style='color: #007bff'/>
            </a>
          </a-tooltip>
          <a-tooltip placement="top" title="Delete" v-if="params.type === 'groupingBank' || params.type === 'tenantBank'">
            <a @click='() => deleteBank()'>
              <i class='fa fa-trash-o deleteIcon mr-2' aria-hidden='true' style='color: #e03848'/>
            </a>
          </a-tooltip>
          <a-tooltip placement="top" title="Edit" v-if="value !== 'Live' && params.type === 'template'">
            <a @click='() => editTemplate()'>
              <i class='fa fa-pencil templateIcon mr-2' aria-hidden='true' style='color: #007bff'/>
            </a>
          </a-tooltip>
          <a-tooltip placement="left" title="View" v-if="value === 'Live' && params.type === 'template'">
            <a @click='() => viewTemplate()'>
              <i class='fa fa-eye templateIcon mr-2' aria-hidden='true' style='color: #007bff'/>
            </a>
          </a-tooltip>
          <a-tooltip placement="left" title="Clone" v-if="params.type === 'analysisSheet'">
            <a @click='() => cloneTemplate()'>
              <i class='fa fa-clone mr-2' :class="params.type === 'analysisSheet'? 'deleteIcon' :'templateIcon'" aria-hidden='true' style='color: #71283e'/>
            </a>
          </a-tooltip>
          <a-tooltip placement="top" title="Publish Template" v-if="value !== 'Live' && params.type === 'template'">
            <a @click='() => publishTemplate()'>
              <i class='fa fa-cloud-upload templateIcon mr-2' aria-hidden='true' style='color: #28a745'/>
            </a>
          </a-tooltip>
          <a-tooltip placement="left" title="Clone" v-if="params.type === 'template'">
            <a @click='() => cloneTemplate()'>
              <i class='fa fa-clone mr-2' :class="params.type === 'analysisSheet'? 'deleteIcon' :'templateIcon'" aria-hidden='true' style='color: #71283e'/>
            </a>
          </a-tooltip>
          <a-tooltip placement="top" title="Delete" v-if="params.type === 'template' && settings.application.allowedTemplateDelete">
            <a @click='() => deleteTemplate()'>
              <i class='fa fa-trash-o deleteIcon' aria-hidden='true' style='color: #e03848'/>
            </a>
          </a-tooltip>
          <a-tooltip
            placement="top"
            title="Save As A Tenant Bank"
            v-if="params.type === 'tenants' && rolePermissions.saveAsTenantBank.includes(role) && params.analysisTypeId !== 2"
          >
            <a @click="() => addToBank()" v-if="params.data.tenantApproachId !== 2">
              <i class="fa fa-save templateIcon" aria-hidden="true" style='color: #007bff'/>
            </a>
          </a-tooltip>
          <a-tooltip title="Delete" placement="top" v-if="params.type === 'tenants'">
            <a @click="() => deleteTenant()">
              <i class="fa fa-trash-o cancel mr-2" aria-hidden="true"/>
            </a>
          </a-tooltip>
          <a-tooltip
            placement="top"
            title="Clone Tenant"
            v-if="params.type === 'tenants'"
            >
            <a @click="() => cloneTenant()">
              <i class="fa fa-clone actionIcon mr-2" aria-hidden="true" style='color: #71283e'/>
            </a>
          </a-tooltip>
          <a-tooltip placement="top" title="Delete" v-if="params.screenType === 'Template' || params.screenType === 'AnalysisSheet' || params.screenType === 'Project'" :disabled="params.screenType === 'Template' && params.data.isLocked">
            <a @click='() => deleteShell()'>
              <i class='fa fa-trash-o deleteIcon mr-2' :disabled="(params.screenType === 'Template' || params.screenType === 'Project') && params.data.isLocked" aria-hidden='true' style='color: #e03848'/>
            </a>
          </a-tooltip>
          <a-tooltip placement="top" title="Delete" v-if="params.type === 'dynamicDelete'|| params.type === 'analysisSheet' || (params.type === 'projectDetails' && !params.data.linkedAssetId && !params.data.isChildLink)" :disabled="(params.type === 'dynamicDelete' && params.data.isLocked)">
            <a @click='() => deleteShell()'>
              <i class='fa fa-trash-o deleteIcon mr-2' :disabled="params.type === 'dynamicDelete' && params.data.isLocked" aria-hidden='true' style='color: #e03848'/>
            </a>
          </a-tooltip>
          <a-tooltip
            placement="top"
            title="Save As A Template"
            v-if="params.type === 'projectDetails' && (params.data.linkMethod !== 1 || !params.data.linkedAssetId) && rolePermissions.saveAsTemplate.includes(role) && params.data.analysisTypeId === 1"
          >
            <a @click="() => saveAsTemplate()">
              <i class="fa fa-save templateIcon mr-2" aria-hidden="true" style='color: #007bff'/>
            </a>
          </a-tooltip>
          <a-tooltip placement="top" title="Delete" v-if="(params.type === 'actualCost' || params.type === 'actualCostTile' || params.type === 'estimateGroup' || params.type === 'estimateTakeoff') && !params.data.isAdjustmentTakeoff">
            <a @click='() => deleteShell()'>
              <i class='fa fa-trash-o deleteIcon mr-2' :disabled="params.type === 'dynamicDelete' && params.data.isLocked" aria-hidden='true' style='color: #e03848'/>
            </a>
          </a-tooltip>
          <a-tooltip placement="left" title="Clone" v-if="(params.type === 'actualCost' || params.type === 'actualCostTile' || params.type === 'estimateGroup' || params.type === 'estimateTakeoff') && !params.data.isAdjustmentTakeoff">
            <a @click='() => cloneTemplate()'>
              <i class='fa fa-clone mr-2' :class="params.type === 'analysisSheet'? 'deleteIcon' :'templateIcon'" aria-hidden='true' style='color: #71283e'/>
            </a>
          </a-tooltip>
          <a-popover title="Missing Fields" trigger="hover"  v-if="params.name === 'validTakeoff' && !params.data.isAdjustmentTakeoff && !params.data.isValidTakeoff">
            <template slot="content">
              <div style="max-height: 300px; overflow-y: auto;">
                <div class="pb-1" v-for="(fields, j) in missingFields" :key="j">
                  <a-tag color="#ff9900">{{ fields }}</a-tag>
                </div>
              </div>
            </template>
          <a>
            <i class="fa fa-exclamation-triangle invalid-icon mr-2" aria-hidden="true" />
          </a>
          </a-popover>
        </a-spin>
      </span>
    </div>
    `,
  data: function() {
    return {
      loader: false,
      value: '',
      role: null,
      rolePermissions: rolePermissions,
      missingFields: [],
      settings: JSON.parse(localStorage.getItem('userSettings')) || {},
    }
  },
  beforeMount() {
    const user = JSON.parse(localStorage.getItem('userDetails'))
    this.role = user.role
    this.value = this.params.data.status
    if (this.params.name === 'validTakeoff') {
      this.showMissingFields()
    }
  },
  methods: {
    unLink() {
      const that = this
      if (this.params.data.analysisTypeId === 1) {
        this.$confirm({
          title: `Are you sure want to unlink this asset?`,
          content: h => (
            <div style="color:red;">
              <p>
                This action will delete all data related to this asset:
                {'  '}
                {this.params.data.description || this.params.data.assetNumber}.
              </p>
              <p>Please confirm</p>
            </div>
          ),
          onOk() {
            that.$root.$emit('unlinkAsset', that.params.data)
          },
          onCancel() {},
        })
      } else {
        this.$confirm({
          title: `Are you sure want to unlink this asset?`,
          onOk() {
            that.$root.$emit('unlinkAsset', that.params.data)
          },
          onCancel() {},
        })
      }
    },

    cloneTemplate() {
      switch (this.params.type) {
        case 'analysisSheet':
          this.$root.$emit('cloneTakeOff', this.params.data.id)
          break
        case 'actualCost':
          this.$root.$emit('cloneTileTakeoff', this.params.data.id)
          break
        case 'actualCostTile':
          this.$root.$emit('cloneLevelTileTakeoff', this.params.data.id)
          break
        case 'estimateGroup':
          this.$root.$emit(
            `onCloneTakeoff${this.params.data.assetId}`,
            this.params.data.id,
          )
          break
        case 'estimateTakeoff':
          this.$root.$emit('onCloneTakeoffs', this.params.data.id)
          break

        default:
          this.$root.$emit(
            'templatesChange',
            this.params.data,
            this.params.rowIndex,
            true,
            'clone',
          )
          break
      }
    },

    publishTemplate() {
      this.$root.$emit(
        'templatesChange',
        this.params.data,
        this.params.data.status === 'Design' ? 'Live' : 'Design',
        true,
        'publish',
      )
    },

    editTemplate() {
      this.$router.push(`templates/${this.params.data.id}`)
    },

    deleteTemplate() {
      this.$root.$emit(
        'templatesChange',
        this.params.data,
        this.params.rowIndex,
        true,
        'delete',
      )
    },

    deleteShell() {
      if (
        this.params.screenType === 'Template' ||
        this.params.screenType === 'AnalysisSheet' ||
        this.params.screenType === 'Project'
      ) {
        if (
          this.params.screenType === 'Project' &&
          this.params.data &&
          this.params.data.isLocked
        ) {
          return null
        } else {
          this.$root.$emit('deleteRecord', this.params.data)
        }
      } else {
        switch (this.params.type) {
          case 'projectDetails':
            this.$root.$emit(
              'deleteAsset',
              this.params.data,
              this.params.rowIndex,
            )
            break
          case 'actualCost':
            this.$root.$emit('deleteTileTakeoff', this.params.data)
            break
          case 'actualCostTile':
            this.$root.$emit('deleteLevelTileTakeoff', this.params.data)
            break
          case 'estimateGroup':
            this.$root.$emit(
              `onDeleteTakeoff${this.params.data.assetId}`,
              this.params.data,
            )
            break
          case 'estimateTakeoff':
            this.$root.$emit('onDeleteTakeoffs', this.params.data)
            break

          default:
            var that = this
            this.$confirm({
              title: `Are you sure want to delete this row?`,
              content: h => (
                <div style="color:red">
                  <p>
                    This action will delete all information related this row.
                  </p>
                  <p>Please confirm.</p>
                </div>
              ),
              onOk() {
                that.loader = true
                instance
                  .patch(that.params.url, [that.params.data.id])
                  .then(response => {
                    that.$root.$emit(
                      'deleteRecord',
                      that.params.rowIndex,
                      that.params.data.id,
                    )
                    that.loader = false
                  })
                  .catch(err => {
                    errorService(err)
                  })
              },
            })
            break
        }
      }
    },

    deleteTenant() {
      if (this.params.screenType === 'BuildingGeneral') {
        this.$root.$emit(
          `deleteTenant${this.params.data.assetId}`,
          this.params.data,
        )
      } else {
        this.$root.$emit('deleteTenant', this.params.data)
      }
    },

    deleteBank() {
      var that = this
      this.$confirm({
        title: `Are you sure want to delete this row?`,
        content: h => (
          <div style="color:red">
            <p>This action will delete all information related this row.</p>
            <p>Please confirm.</p>
          </div>
        ),
        onOk() {
          that.$root.$emit('showLoader', true)
          that.loader = true
          let url = masterAPIs.bank.delete
          switch (that.params.type) {
            case 'tenantBank':
              url = masterAPIs.tenantBank.takeoff.delete
              break
            case 'groupingBank':
              url = masterAPIs.groupingBank.takeoff.delete
              break
          }
          instance
            .patch(url, [that.params.data.id])
            .then(response => {
              that.$root.$emit(
                'deleteRecord',
                that.params.rowIndex,
                that.params.data.id,
              )
            })
            .catch(err => {
              that.$root.$emit('showLoader', true)
              errorService(err)
            })
        },
      })
    },

    addToBank() {
      if (this.params.screenType === 'BuildingGeneral') {
        this.$root.$emit(
          `addInBank${this.params.data.assetId}`,
          this.params.data,
        )
      } else {
        this.$root.$emit('addInBank', this.params.data)
      }
    },

    viewTemplate() {
      this.$router.push(`templates/${this.params.data.id}`)
    },

    saveAsTemplate() {
      this.$root.$emit('saveAsTemplate', this.params.data)
    },

    cloneTenant() {
      if (this.params.screenType === 'BuildingGeneral') {
        this.$root.$emit(
          `cloneTenant${this.params.data.assetId}`,
          this.params.data,
        )
      } else {
        this.$root.$emit('cloneTenant', this.params.data)
      }
    },

    showMissingFields() {
      this.missingFields = []
      if (
        this.params.data &&
        !this.params.data.isAdjustmentTakeoff &&
        !this.params.data.isValidTakeoff
      ) {
        const columns = _.get(
          this.params.columnApi,
          'columnController.columnDefs',
          [],
        )
        checkFields.forEach(element => {
          if (!this.params.data[element]) {
            const data = columns.find(i => i.field === element)
            let isCheck = true
            if (element === 'contract' || element === 'categoryCode') {
              if (this.params.data.mCostTypeId) {
                isCheck = !costTypes.includes(this.params.data.mCostTypeId)
              }
            }
            if (data && isCheck) {
              this.missingFields.push(data.headerName)
            }
          }
        })
      }
    },
  },
})
